module.exports = __webpack_public_path__ + "img/1699344649327-WhatsApp Image 2023-11-07 at 16.05.27.jpeg.582a179b.webp";